import { Component, OnInit, AfterContentInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { UsuarioService } from 'src/app/services/usuario.service';
import { ToastrService } from 'ngx-toastr';
import { Security } from 'src/app/utils/security.util';
import { Router } from '@angular/router';

@Component({
    selector: 'app-usuario-alterar-senha-page',
    templateUrl: './usuario-alterar-senha-page.component.html',
    providers: [UsuarioService]
})
export class UsuarioAlterarSenhaPageComponent implements OnInit {
    public form: FormGroup;
    private usuarioLogadoId = 0;

    constructor(
        private _usuarioService: UsuarioService,
        private _toastr: ToastrService,
        private _router: Router,
    ) { }

    ngOnInit() {
        this.usuarioLogadoId = this._usuarioService.getUsuarioLogadoId();
        this.resetForm();
    }

    public resetForm(): void {
        this.form = new FormGroup({
            id: new FormControl(this.usuarioLogadoId),
            senhaNova: new FormControl('', [Validators.required])
        });
    }

    public submit() {
        const id = this.form.controls['id'].value;
        this._usuarioService.alterarSenha(id, this.form.value).subscribe(
            (response: any) => {
                this._toastr.success('Senha alterada com sucesso');
                this.resetForm();
                this._logout()
            },
            (err: any) => {
                this._toastr.error('Não foi possível alterar a senha');
            }
        );
    }

    private _logout(): void {
        Security.clear();
        this._router.navigate(['']);
    }


}
